import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CompanyService } from '../../services/company.service';
import { FormsService } from '../../services/forms.service';
import { OverlayService } from '../../services/overlay.service';
import { Store } from '../../store';

@Component({
    selector: 'app-supplier',
    templateUrl: './supplier.component.html',
    styleUrls: ['./supplier.component.scss'],
})
export class SupplierComponent implements OnInit {
    @Input() company;
    @Output() next = new EventEmitter();

    form: FormGroup;

    constructor(
        private fb: FormBuilder,
        private overlayService: OverlayService,
        private store: Store,
        private companyService: CompanyService,
        private formsService: FormsService
    ) {
        this.form = this.fb.group({
            name: ['', [Validators.required, Validators.minLength(2)]],
            url: ['', [Validators.minLength(2)]],
            email: ['', [Validators.required, Validators.email]],
            mobile: [''],
            landline: [''],
            companyNumber: ['', [Validators.minLength(2)]],
            vatNumber: ['', [Validators.minLength(2)]],
            restrictions: ['', []],
        });
    }

    ngOnInit(): void {
        this.form.patchValue({
            name: this.company.name,
            url: this.company.url,
            email: this.company.email,
            landline: this.company.landline,
            companyNumber: this.company.companyNumber,
            vatNumber: this.company.vatNumber,
            restrictions: this.company.restrictions,
        });
    }

    onSubmit() {
        this.company.name = this.form.value.name;
        this.company.url = this.form.value.url;
        this.company.companyNumber = this.form.value.companyNumber;
        this.company.vatNumber = this.form.value.vatNumber;
        this.company.email = this.form.value.email;
        this.company.mobile = this.form.value.mobile?.e164Number ?? '';
        this.company.mobDialCode = this.form.value.mobile?.dialCode ?? '';
        this.company.landline = this.form.value.landline?.e164Number ?? '';
        this.company.restrictions = this.form.value.restrictions;
        this.next.emit();
    }

    findInvalidControls() {
        return this.formsService.findInvalidControls(this.form);
    }
}
